import { Component } from "@angular/core";

@Component({
  templateUrl: "./fatal-error.component.html",
  styleUrls: ["./fatal-error.component.scss"],
})
export class FatalErrorComponent {
  constructor() {}
}
